
<div class="performance-container" [ngClass]="rootClassName">
  @defer (when !isLoading) {
      <pop-ui-drawer [(state)]="drawerState"></pop-ui-drawer>
  } @placeholder {
    <nx-superprep-dot-flashing></nx-superprep-dot-flashing>
  }
</div>
